import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Search from "@material-ui/icons/Search";
import Email from "@material-ui/icons/Email";
import Face from "@material-ui/icons/Face";
import AccountCircle from "@material-ui/icons/AccountCircle";
import Explore from "@material-ui/icons/Explore";
// React icons
import { FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Header from "components/Header/Header.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";

import navbarsStyle from "assets/jss/material-kit-react/views/componentsSections/navbarsStyle.jsx";

import image from "assets/img/bg.jpg";
import red_right from 'assets/img/sprites/red_right.png';
import red_ahead from 'assets/img/sprites/red_ahead.png';
import red_left from 'assets/img/sprites/red_left.png';
import Menu from 'assets/img/sprites/Menu.png';
import Ranking_background from 'assets/img/sprites/Ranking_background.png';
import Instrucciones from 'assets/img/sprites/Instrucciones.png';
import puas_1_2 from 'assets/img/sprites/puas_1-2.png';
import puas_1_3 from 'assets/img/sprites/puas_1-3.png';
import puas_2_3 from 'assets/img/sprites/puas_2-3.png';
import Warnig_2 from 'assets/img/sprites/Warnig_2.png';
import Warnig_3 from 'assets/img/sprites/Warnig_3.png';
import Warnig_4 from 'assets/img/sprites/Warnig_4.png';
import PLAY_DWN from 'assets/img/sprites/PLAY_DWN.png';
import Menu_DOWN from 'assets/img/sprites/Menu_DOWN.png';
import BACK_DWN from 'assets/img/sprites/BACK_DWN.png';

import profileImage from "assets/img/faces/avatar.jpg";

class SectionNavbars extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title}>
                <h3>Authors and Contributors</h3>
              </div>
              <p>Created, designed, programmed and distributed by <b>Luis C. Isaula</b> and <b>Kevin J. Estevez</b>. Here is a list of the assets used during design phase, having in mind that all was handmade.</p>
            </GridItem>

          {/* Cars */}
            <GridItem xs={12} sm={12} md={4}>
              <h4>Fire Car</h4>
              <h6>Right Face</h6>
                <img
                  width='100%'
                  src={red_right}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Fire Car</h4>
              <h6>Back Face</h6>
                <img
                  width='100%'
                  src={red_ahead}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Fire Car</h4>
              <h6>Left Face</h6>
                <img
                  width='100%'
                  src={red_left}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
              <p style={{padding: '2em 0', textAlign: 'right'}}>All the cars were made by KenyStev.</p>
            </GridItem>

          {/* Screens */}
            <GridItem xs={12} sm={12} md={4}>
              <h4>Menu screen</h4>
                <img
                  width='100%'
                  src={Menu}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4>Best Scores screen</h4>
                <img
                  width='100%'
                  src={Ranking_background}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4>Instructions screen</h4>
                <img
                  width='100%'
                  src={Instrucciones}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
              <p style={{padding: '2em 0', textAlign: 'right'}}>All backgrounds and logo were made by Lisaula.</p>
            </GridItem>

          {/* Steps */}
            <GridItem xs={12} sm={12} md={4}>
              <h4>Barbed-racetrack</h4>
              <h6>Racecourse with tines on left.</h6>
                <img
                  width='100%'
                  src={puas_1_2}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Barbed-racetrack</h4>
              <h6>Racecourse with tines on borders.</h6>
                <img
                  width='100%'
                  src={puas_1_3}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Barbed-racetrack</h4>
              <h6>Racecourse with tines on right.</h6>
                <img
                  width='100%'
                  src={puas_2_3}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
              <p style={{padding: '2em 0', textAlign: 'right'}}>All the racetracks were made by KenyStev.</p>
            </GridItem>

          {/* Warning */}
            <GridItem xs={12} sm={12} md={4}>
              <h4>Warning</h4>
              <h6>Motion animation.</h6>
                <img
                  width='100%'
                  src={Warnig_2}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Warning</h4>
              <h6 style={{color: 'transparent'}}>Motion animation.</h6>
                <img
                  width='100%'
                  src={Warnig_3}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4 style={{color: 'transparent'}}>Warning</h4>
              <h6 style={{color: 'transparent'}}>Motion animation.</h6>
                <img
                  width='100%'
                  src={Warnig_4}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
              <p style={{padding: '2em 0', textAlign: 'right'}}>All motion animations were made by Lisaula.</p>
            </GridItem>

          {/* Buttons */}
            <GridItem xs={12} sm={12} md={4}>
              <h4>Play button</h4>
                <img
                  width='100%'
                  src={PLAY_DWN}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4>Menu button</h4>
                <img
                  width='100%'
                  src={Menu_DOWN}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <h4>Back button</h4>
                <img
                  width='100%'
                  src={BACK_DWN}
                  alt="..."
                  className={
                    classes.imgRaised +
                    " " +
                    classes.imgRounded +
                    " " +
                    classes.imgFluid
                  }
                />
              <p style={{padding: '2em 0', textAlign: 'right'}}>All buttons were made by Lisaula.</p>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <h2>Support or Contact</h2>
              <h4>
                If you're having any trouble while playing, feel free to create a new
                <a
                  href="https://github.com/kenystev/racergear/issues"
                  target="_blank"
                >
                  {" "}issue{" "}
                </a>
                and we'll fix it as soon as posible.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(navbarsStyle)(SectionNavbars);
